export default __webpack_public_path__ + "media/src/assets/images/Chevron-83c11ecc2d9916efc7790b394af4b804.svg";